import { getLocaleUrlFromFullSlug } from '@utils/getTranslatedStory';

import { EmailLink } from './links/EmailLink';
import { ExternalButton } from './links/ExternalButton';
import { ExternalLink } from './links/ExternalLink';
import { InternalLink } from './links/InternalLink';

type LinkMarkResolverProps = {
  localePrefix: string;
};

export const LinkMarkResolver =
  ({ localePrefix }: LinkMarkResolverProps) =>
  (children: React.ReactNode, props: any) => {
    if (!props) return null;

    const { href, target, linktype, story, custom } = props;
    const isButton = custom?.buttonColor != null;
    const buttonColor = custom?.buttonColor;

    if (linktype === 'story') {
      return InternalLink({
        children,
        href: story
          ? getLocaleUrlFromFullSlug(story.full_slug, localePrefix)
          : getLocaleUrlFromFullSlug(href, localePrefix),
        story,
        target,
      });
    } else if (linktype === 'url' && isButton) {
      return ExternalButton({ href, target, children, buttonColor });
    } else if (linktype === 'url' || linktype === 'asset') {
      const externalTarget = linktype === 'asset' ? '_blank' : target;
      return ExternalLink({ href, children, target: externalTarget });
    } else if (linktype === 'email') {
      return EmailLink({ href, children });
    }

    return linktype;
  };
